import splunkLoggingSingleton from './splunk-logging-singleton';

const port = window.location.port ? `:${window.location.port}` : '';
const locationOrigin =
  `${window.location.origin}` || `${window.location.protocol}//${window.location.host}${port}`;
const logButtonClick = initData => {
  // Skip splunk logs when running in cypress
  if (splunkLoggingSingleton.isCypressMode === true) {
    return;
  }

  const SPAStartTime = new Date().getTime();
  const r = new XMLHttpRequest();

  const correlationId = initData?.srciTransactionId;
  const apikey = initData?.srcInitiatorId;

  const initDpaTransactionOptions = initData?.dpaTransactionOptions;
  const clientId = initDpaTransactionOptions?.customData?.clientId ?? '';
  const externalClientId = initDpaTransactionOptions?.customData?.externalClientId ?? '';
  const countryCode = initDpaTransactionOptions?.merchantCountryCode;

  const url = `${locationOrigin}/logging/logEvent`;

  const loggingData = {
    CO: 'JSSDK',
    Country: countryCode,
    E: 'EXT_SRCI_LOAD',
    LL: 'INFO',
    ME: clientId ? clientId : undefined,
    O: 'JSSDK',
    OS: navigator.platform,
    RTY: 'OUT',
    S: '200',
    T: 'E',
    TS: SPAStartTime,
    U: '/checkout-widget',
    XCL: externalClientId || undefined,
    'x-merchant-api-key': apikey
  };

  r.open('POST', url, true);
  r.setRequestHeader('Accept', 'application/json');
  r.setRequestHeader('Content-type', 'application/json');
  r.setRequestHeader('X-CORRELATION-ID', correlationId);
  r.setRequestHeader('X-VISIT-ID', undefined);
  r.send(JSON.stringify(loggingData));
};

export default logButtonClick;
